import { createFileRoute } from "@tanstack/react-router";

import { OnboardingQuestionsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/onboarding-questions")({
  component: OnboardingQuestionsPage,
});
